import { render } from "./MItem.vue?vue&type=template&id=ec2c1a1c&scoped=true&ts=true"
import script from "./MItem.vue?vue&type=script&lang=ts"
export * from "./MItem.vue?vue&type=script&lang=ts"

import "./MItem.vue?vue&type=style&index=0&id=ec2c1a1c&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2c1a1c"]])

export default __exports__